import { render } from "./TableWithTitle.vue?vue&type=template&id=ab2a3226&scoped=true"
import script from "./TableWithTitle.vue?vue&type=script&lang=js"
export * from "./TableWithTitle.vue?vue&type=script&lang=js"

import "./TableWithTitle.vue?vue&type=style&index=0&id=ab2a3226&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ab2a3226"]])

export default __exports__